import { Cart } from "@commercetools/platform-sdk"
import { CartValidationBase, cartSuccess } from "../../validation/FormValidator"
import { CartValidationResult } from "../../validation/ValidationError"

export class FraudValidation extends CartValidationBase {
  private readonly validateFraud: (cartId: string) => Promise<Cart>
  constructor(validateFraud: (cartId: string) => Promise<Cart>) {
    super("FraudValidation")
    this.validateFraud = validateFraud
  }

  validate(c: Cart): CartValidationResult {
    return this.validateFraud(c.id).then(cartSuccess)
  }
}
